<template>
    <div>
        <div class="module">
            <div class="module-tit">
                <img src="../../static/images/2.png" alt="">
                <span>收入</span>
            </div>
            <ul class="module-ul">
                <li class="module-li">
                    <span class="module-li-tit">
                        经营所得
                        <i class="icon iconfont icon-bangzhu-" @click="isShowJingyingsuode = !isShowJingyingsuode"></i>
                    </span>
                    <input v-model.lazy="jingyingsuode" @change="jingyingsuodeChange" class="module-li-short" type="text">
                    <span>元</span>
                    <div v-show="isShowJingyingsuode" class="explain">
                        <i class="icon iconfont icon-guanbi" @click="isShowJingyingsuode = false"></i>
                        <h1>经营所得：</h1>
                        <p>个人通过在中国境内注册登记的个体工商户、个人独资企业、合伙企业从事生产、经营活动取得的所得；个人依法取得执照，从事办学、医疗、咨询以及其他有偿服务活动取得的所得；个人承包、承租、转包、转租取得的所得</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="module">
            <div class="module-tit">
                <img src="../../static/images/2.png" alt="">
                <span>扣除及减除项目</span>
            </div>
            <ul class="module-ul">
                <li class="module-li">
                    <span class="module-li-tit">成本费用</span>
                    <input v-model.lazy="chengbenfeiyong" @change="chengbenfeiyongChange" class="module-li-short" type="text">
                    <span>元</span>
                </li>
                <li class="module-li">
                    <span class="module-li-tit">弥补以前年度亏损</span>
                    <input v-model.lazy="mibu" @change="mibuChange" class="module-li-short" type="text">
                    <span>元</span>
                </li>
                <li class="module-li">
                    <span class="module-li-tit">合伙企业合伙人分配比例</span>
                    <input v-model.lazy="fenpeibili"  class="module-li-short" type="number">
                    <span>%</span>
                </li>
                <li class="module-li">
                    <span class="module-li-tit">
                        投资者减除费用
                        <i class="icon iconfont icon-bangzhu-" @click="isShowTouzizhe = !isShowTouzizhe"></i>
                    </span>
                    <input v-model.lazy="touzizhe"  @change="touzizheChange" class="module-li-short" type="text">
                    <span>元</span>
                    <div v-show="isShowTouzizhe" class="explain">
                        <i class="icon iconfont icon-guanbi" @click="isShowTouzizhe = false"></i>
                        <h1>投资者减除费用：</h1>
                        <p>2018年10月1日前按3500扣除，10月1日后按5000扣除</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="btn" @click="computerClick">
            计算
        </div>
        <div class="module">
            <div class="module-tit">
                <img src="../../static/images/2.png" alt="">
                <span>计算结果</span>
            </div>
            <ul class="module-ul">
                <li class="module-li">
                    <span class="module-li-tit">税前收入</span>
                    <input v-model="beforeIncome" class="module-li-short" type="text" readonly>
                    <span>元</span>
                </li>
                <li class="module-li">
                    <span class="module-li-tit">应纳税额</span>
                    <input v-model="taxAmount" class="module-li-short" type="text" readonly>
                    <span>元</span>
                </li>
                <li class="module-li">
                    <span class="module-li-tit">税后收入</span>
                    <input v-model="afterIncome" class="module-li-short" type="text" readonly>
                    <span>元</span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    import number from '../../static/js/number'
    import unNumber from '../../static/js/unNumber'
    export default {
        data () {
            return {
                jingyingsuode:'',//经营所得
                chengbenfeiyong:'',//成本费用
                mibu:'',//弥补以前年度亏损
                fenpeibili:100,//合伙企业合伙人分配比例
                touzizhe:'',//投资者减除费用

                isShowJingyingsuode:false,//是否显示经营所得说明
                isShowTouzizhe:false,//是否显示投资者减除费用说明

                beforeIncome:0,//税前收入
                taxAmount:0,//应纳税额
                afterIncome:0,//税后收入
            }
        },
        watch:{
            fenpeibili:function(val){
                if(val > 100 || val < 0){
                    this.fenpeibili = 100
                }
            }
        },
        methods:{
            jingyingsuodeChange(){
                let val = unNumber.unNumber(this.jingyingsuode)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.jingyingsuode = '0.00'
                }else{
                    this.jingyingsuode = number.number(this.jingyingsuode)
                }
            },
            chengbenfeiyongChange(){
                let val = unNumber.unNumber(this.chengbenfeiyong)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.chengbenfeiyong = '0.00'
                }else{
                    this.chengbenfeiyong = number.number(this.chengbenfeiyong)
                }
            },
            mibuChange(){
                let val = unNumber.unNumber(this.mibu)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.mibu = '0.00'
                }else{
                    this.mibu = number.number(this.mibu)
                }
            },

            touzizheChange(){
                let val = unNumber.unNumber(this.touzizhe)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.touzizhe = '0.00'
                }else{
                    this.touzizhe = number.number(this.touzizhe)
                }
            },

            computerClick(){
                let jingyingsuode = unNumber.unNumber(this.jingyingsuode) //经营所得
                let chengbenfeiyong = unNumber.unNumber(this.chengbenfeiyong)//成本费用
                let mibu = unNumber.unNumber(this.mibu)//弥补以前年度亏损
                let fenpeibili = unNumber.unNumber(this.fenpeibili)//合伙企业合伙人分配比例 判断是否为0或者为空
                let touzizhe = unNumber.unNumber(this.touzizhe)//投资者减除费用
                let x = 0
                console.log(jingyingsuode);
                if(jingyingsuode - chengbenfeiyong - mibu > 0){
                    x = (jingyingsuode - chengbenfeiyong - mibu) * fenpeibili / 100 - touzizhe
                    x = x > 0 ? x : 0
                    this.taxAmount = this.tax1(x).toFixed(2)
                }else{
                    this.taxAmount = 0
                }
                this.beforeIncome = number.number(((jingyingsuode - chengbenfeiyong - mibu) * fenpeibili / 100).toFixed(2))
                this.afterIncome = jingyingsuode - chengbenfeiyong - mibu > 0 ? number.number(((jingyingsuode - chengbenfeiyong - mibu) * fenpeibili / 100 - this.taxAmount).toFixed(2)) : 0
                this.taxAmount = number.number(this.taxAmount)
            },
            tax1(n){
                return n <= 30000 ? ( n * 0.05) :
                    n <= 90000 ? ( n * 0.1 - 1500) :
                        n <= 300000 ? ( n * 0.2 - 10500) :
                            n <= 500000 ? ( n * 0.3 - 40500) : ( n * 0.35 - 65500)
            },
        },
    }
</script>
<style scoped>
    .module{
        width:100%;
        margin-top: 30px;
        text-align: left;
    }
    .module .module-tit{
        display: inline-block;
        border-bottom: 1px solid #1a96d4;
        padding: 5px 15px 5px 10px;
        font-size:16px;
    }
    .module .module-tit #all{
        width:16px;
        height:16px;
    }
    .module .module-ul{
        width:100%;
        font-size:0;
    }
    .module .module-ul .module-li{
        display: inline-block;
        width:50%;
        height:36px;
        font-size:14px;
        color: #333;
        margin-top:20px;
        position: relative;
    }
    .module .module-ul .module-li .module-li-tit{
        display: inline-block;
        width:140px;
        height:100%;
        font-size: 14px;
        margin-left: 20px;
        margin-right: 10px;
        vertical-align: middle;
    }
    .module .module-ul .module-li .module-li-tit .icon-bangzhu-{
        display: inline-block;
        float: right;
        font-size:20px;
        color: #1a96d4;
        cursor: pointer;
        vertical-align: middle;
    }
    .module .module-ul .module-li .module-li-short{
        display: inline-block;
        width:270px;
        height:32px;
        line-height: 1;
        font-size:14px;
        text-align: center;
        border: 1px solid #b9e9f2;
    }
    .module .module-ul .module-li .explain{
        display: block;
        width:500px;
        position: absolute;
        border: 1px solid #1a96d4;
        border-radius: 10px;
        top:36px;
        left:0px;
        background-color: #fff;
        z-index:100;
        padding: 10px 20px;
        box-shadow:5px 5px 20px -5px #ccc
    }
    .module .module-ul .module-li .explain .icon-guanbi{
        position: absolute;
        top:5px;
        right:5px;
        font-size:20px;
        cursor: pointer;
    }
    .module .module-ul .module-li .explain h1{
        font-size:20px;
        color: #333;
    }
    .module .module-ul .module-li .explain p{
        font-size:18px;
        color: #333;
    }
    .module .module-ul .module-li-choice .choice.selected{
        border: 1px solid #1a96d4;
        color: #1a96d4;
        background-color: #d1edf8;
    }
    .module .module-ul .module-subheading{
        width:100%;
        border-bottom: 1px solid #ccc;
        padding: 10px 0;
        position: relative;
    }
    .module .module-ul .module-subheading span{
        font-size:14px;
        color: #333;
        border-left:1px solid #1a96d4;
        padding-left: 10px;
    }
    .module .module-ul .module-subheading span .icon-bangzhu-{
        display: inline-block;
        font-size:20px;
        color: #1a96d4;
        cursor: pointer;
        vertical-align: middle;
    }
    .module .module-ul .module-subheading .explain{
        display: block;
        width:500px;
        position: absolute;
        border: 1px solid #1a96d4;
        border-radius: 10px;
        top:36px;
        left:0px;
        background-color: #fff;
        z-index:100;
        padding: 10px 20px;
        box-shadow:5px 5px 20px -5px #ccc
    }
    .module .module-ul .module-subheading .explain .icon-guanbi{
        position: absolute;
        top:5px;
        right:5px;
        font-size:20px;
        cursor: pointer;
    }
    .module .module-ul .module-subheading .explain h1{
        font-size:20px;
        color: #333;
    }
    .module .module-ul .module-subheading .explain p{
        font-size:18px;
        color: #333;
    }
    .module .module-ul .module-li-choice{
        display: inline-block;
        width:50%;
        height:36px;
        font-size:14px;
        color: #333;
        margin-top:20px;
    }
    .module .module-ul .module-li-choice .choice{
        width:440px;
        height:32px;
        border: 1px solid #ccc;
        text-align: center;
        line-height: 32px;
        color: #333;
        margin-left: 10px;
        cursor: pointer;
    }
    .module .module-ul .module-li-choice .choice-input{
        width:440px;
        height:32px;
        border: 1px solid #b9e9f2;
        text-align: center;
        line-height: 32px;
        color: #333;
        margin-left: 10px;
    }
    .btn{
        display: inline-block;
        width: 224px;
        height: 42px;
        font-size:22px;
        color: #fff;
        background-color: #13b5ea;
        text-align: center;
        line-height: 42px;
        border-radius: 3px;
        margin-top: 40px;
        cursor: pointer;
    }
    @media screen and (max-width:768px) {
        .module{
            width:100%;
            margin-top: 0.1rem;
        }
        .module .module-tit{
            display: inline-block;
            border-bottom: 1px solid #1a96d4;
            padding: 0.05rem 0.15rem 0.05rem 0.1rem;
            font-size:0.3rem;
        }
        .module .module-tit img{
            width:0.3rem;
            height:0.3rem;
        }
        .module .module-tit #all{
            width:0.3rem;
            height:0.3rem;
        }
        .module .module-ul{
            width:100%;
            font-size:0;
        }
        .module .module-ul .module-li{
            display: inline-block;
            width:100%;
            height:0.6rem;
            font-size:0.24rem;
            margin-top:0.2rem;
        }
        .module .module-ul .module-li .module-li-tit{
            display: inline-block;
            width:2.3rem;
            height:100%;
            font-size: 0.24rem;
            margin-left: 0rem;
            margin-right: 0.1rem;
        }
        .module .module-ul .module-li .module-li-tit .icon-bangzhu-{
            display: inline-block;
            float: right;
            font-size:0.3rem;
            color: #1a96d4;
            cursor: pointer;
            vertical-align: middle;
        }
        .module .module-ul .module-li .module-li-short{
            display: inline-block;
            width:2.6rem;
            height:100%;
            font-size:0.24rem;
            border: 1px solid #b9e9f2;
        }
        .module .module-ul .module-li .explain{
            display: block;
            width:5rem;
            position: absolute;
            border: 1px solid #1a96d4;
            border-radius: 10px;
            top:0.6rem;
            left:0;
            background-color: #fff;
            z-index:100;
            padding: 0.1rem 0.2rem;
            box-shadow:5px 5px 20px -5px #ccc
        }
        .module .module-ul .module-li .explain .icon-guanbi{
            position: absolute;
            top:5px;
            right:5px;
            font-size:0.3rem;
            cursor: pointer;
        }
        .module .module-ul .module-li .explain h1{
            font-size:0.3rem;
            color: #333;
        }
        .module .module-ul .module-li .explain p{
            font-size:0.24rem;
            color: #333;
        }
        .module .module-ul .module-subheading{
            width:100%;
            border-bottom: 1px solid #ccc;
            padding: 0.2rem 0;
        }
        .module .module-ul .module-subheading span{
            font-size:0.24rem;
            padding-left: 0.2rem;
        }
        .module .module-ul .module-subheading span .icon-bangzhu-{
            display: inline-block;
            font-size:0.3rem;
            color: #1a96d4;
            cursor: pointer;
            vertical-align: middle;
        }
        .module .module-ul .module-subheading .explain{
            display: block;
            width:5rem;
            position: absolute;
            border: 1px solid #1a96d4;
            border-radius: 10px;
            top:0.6rem;
            left:0;
            background-color: #fff;
            z-index:100;
            padding: 0.1rem 0.2rem;
            box-shadow:5px 5px 20px -5px #ccc
        }
        .module .module-ul .module-subheading .explain .icon-guanbi{
            position: absolute;
            top:5px;
            right:5px;
            font-size:0.3rem;
            cursor: pointer;
        }
        .module .module-ul .module-subheading .explain h1{
            font-size:0.3rem;
            color: #333;
        }
        .module .module-ul .module-subheading .explain p{
            font-size:0.24rem;
            color: #333;
        }
        .module .module-ul .module-li-choice{
            display: inline-block;
            width:100%;
            height:0.6rem;
            font-size:0.24rem;
            margin-top:0.2rem;
        }
        .module .module-ul .module-li-choice .choice{
            width:90%;
            height:0.6rem;
            text-align: center;
            line-height: 0.6rem;
            cursor: pointer;
            margin-left: 5%;
        }
        .module .module-ul .module-li-choice .choice.selected{
            border: 1px solid #1a96d4;
            color: #1a96d4;
            background-color: #d1edf8;
        }
        .module .module-ul .module-li-choice .choice-input{
            width:90%;
            height:0.6rem;
            text-align: center;
            line-height: 0.6rem;
            margin-left: 5%;
            padding: 0;
        }

        .btn{
            display: inline-block;
            width: 2rem;
            height: 0.6rem;
            font-size:0.36rem;
            line-height: 0.6rem;
            margin-top: 0.4rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/production.vue